(() => {
  if (window.JJEvergreenProof) return;
  window.JJEvergreenProof = true;
  const init = () => {
    document.querySelectorAll('[data-ev-demo]').forEach((button) => {
      if (button.dataset.bound) return;
      const dialog = document.getElementById(button.dataset.evDemo);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      button.dataset.bound = 'true';
      button.hidden = false;
      const video = dialog.querySelector('video');
      button.addEventListener('click', () => {
        dialog.showModal();
        document.dispatchEvent(new Event('jj:overlay-change'));
        video?.play().catch(() => {});
      });
      dialog.querySelector('[data-ev-demo-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { video?.pause(); window.dispatchEvent(new Event('resize')); });
    });
  };
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
